import {Component} from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-vermogensvergelijking',
  templateUrl: './tekst-vermogensvergelijking.component.html',
  styleUrls: ['./tekst-vermogensvergelijking.component.scss'],
})
export class TekstVermogensvergelijkingComponent {}
